export default __webpack_public_path__ + "static/media/paper_icon.c2c13c7d.svg";